// extracted by mini-css-extract-plugin
module.exports = {"root":"Hub_root__zxSJZ","head":"Hub_head__XpKjC","eyebrow":"Hub_eyebrow__2eH6i","title":"Hub_title__7cQPq","intro":"Hub_intro__ifVzS","grid":"Hub_grid__Xp7iD"};